// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bxxrXkMHbiUlFH {
  grid-area: statetaxid;
}
.bxxrXkMHbiUlFH svg {
  display: none;
}
.vgnYslTsieZlI5 input {
  width: 40px;
  height: 24px;
  clip: auto;
}
.DPE8wbECtLbhZc {
  margin-left: 38px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"isVatRegistered": `bxxrXkMHbiUlFH`,
	"vatCheckbox": `vgnYslTsieZlI5`,
	"isVatRegisteredLabel": `DPE8wbECtLbhZc`
};
export default ___CSS_LOADER_EXPORT___;
